import Router from "./library/DomBasedRouter";
import React from "react";
import ReactDOM from "react-dom";
import "slick-carousel";
import copy from "copy-to-clipboard";
import $ from "jquery";

import TileFilter from "./components/TileFilter";
import PaginatedTileFilter from "./components/PaginatedTileFilter";
import loadNewsWrapper from "./library/loadNews";
import newsScroll from "./library/newsScroll";

const skrollr = require("skrollr");

// const ElementQueries = require('css-element-queries/src/ElementQueries');
const ElementQueries = require("css-element-queries/src/ElementQueries");

const router = new Router({
  common: {
    init() {
      const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
      const mobileMenuClose = document.querySelector(".mobile-menu-close");
      const mobileMenu = document.querySelector(".mobile-menu-wrapper");

      const mobileLis = document.querySelectorAll(
        "#mobile-menu > li.menu-item-has-children"
      );
      const mobileSubmenu = document.querySelectorAll(
        "#mobile-menu ul.sub-menu"
      );

      mobileMenuToggle.addEventListener(
        "click",
        e => {
          mobileMenu.classList.add("open");
          mobileMenuToggle.classList.add("active");
        },
        false
      );

      mobileLis.forEach(mobileLi => {
        $(mobileLi).click(function(e) {
          $(this)
            .siblings()
            .removeClass("open");
          $(this).toggleClass("open");
        });
      });

      document.addEventListener(
        "click",
        e => {
          e = e || window.event;
          var target = e.target || e.srcElement;
          if (target.closest(".mobile-menu-close") !== null) {
            mobileMenu.classList.remove("open");
          }
        },
        false
      );

      if (document.body.classList.contains("admin-bar")) {
        document.documentElement.classList.add("admin-bar");
      }

      if ($(".testimonial").length) {
        $(".team-testimonial-carousel-slick").slick({
          dots: true,
          rows: 0,
          infinite: false,
          customPaging: function(slider, i) {
            const headshot = $(slider.$slides[i]).data("headshotUrl");
            return `<a href="javascript:void(0);" class="custom-slick-dot">
              &nbsp;
              <div class="headshot-dot" style="background: url(${headshot}) no-repeat center center; background-size: cover;"></div>
            </a>`;
          }
        });
      }

      /* Hero Media hover */
      const heroMediaCalloutButton = $(".hero-media__callout a");
      if (heroMediaCalloutButton.length) {
        $(heroMediaCalloutButton).hover(e => {
          $(e.target)
            .parents(".hero-media")
            .toggleClass("hovering");
        });
      }

      $(".carousel-focus-area-slide").slick({
        dots: true,
        rows: 0,
        customPaging: function(slider, i) {
          const term = $(slider.$slides[i]).data("termname");
          return `<a class="dot-name" href="javascript:void(0);"><span>${
            term.split(" &")[0]
          }</span>${
            term.split(" &").length > 1
              ? " &" +
                term
                  .split(" &")
                  .slice(1)
                  .join(" &")
              : ""
          }</a>`;
        }
      });

      $(".carousel-focus-area-slide .theme-btn").hover(function(e) {
        $(this)
          .parents(".slick-active")
          .toggleClass("zoom");
      });

      $(".carousel-slide").slick({
        dots: true,
        rows: 0,
        customPaging: (slider, i) => {
          return `<a href="javascript:void(0);" class="custom-slick-dot">`;
        }
        // infinite: false
      });

      $(".carousel-slide-two").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true
        // infinite: false
      });

      /**
       * Make share link buttons work
       */
      $("main").on("click", ".copy-url-to-clipboard", function(e) {
        e.stopPropagation();
        e.preventDefault();
        const url = $(this).data("url") || window.location.href;
        copy(url);
        let { top, left } = $(this).offset();
        let padding = 10;
        top += 10 + $(this).outerHeight();
        const newConfirm = $(".copy-to-clipboard-confirm").clone();
        $(".url", newConfirm).text(url);
        $(newConfirm)
          .css({ top, left, display: "flex" })
          .appendTo("body");

        setTimeout(() => {
          $(newConfirm).fadeOut(() => {
            $(newConfirm).remove();
          });
        }, 3000);

        // $( '.copy-to-clipboard-confirm' ).clone().appendTo( 'body' );

        // console.log(url)
      });

      //attaches to DOMLoadContent
      ElementQueries.listen();

      //or if you want to trigger it yourself.
      // Parse all available CSS and attach ResizeSensor to those elements which have rules attached
      // (make sure this is called after 'load' event, because CSS files are not ready when domReady is fired.
      ElementQueries.init();

      const monitorFooterSizes = () => {
        /*
        --footerLowerHeight: 105px;
        --realFooterHeight: 608px;
        */
        document.documentElement.style.setProperty(
          "--footerLowerHeight",
          `${$("footer .lower").innerHeight()}px`
        );
      };
      monitorFooterSizes();
      $(window).resize(monitorFooterSizes);

      // if (navigator.userAgent.toLowerCase().indexOf('android') === -1) {
      //   window.skrollr = skrollr.init({ forceHeight: false });
      // }
      // window.skrollr = skrollr.init({
      //   forceHeight: false,
      //   constants: {
      //     windowheight: () => {
      //       return 1.0 * window.innerHeight
      //     }
      //   }
      // })

      document.addEventListener(
        "wpcf7mailsent",
        function(event) {
          window.location.href = "/thank-you/";
        },
        false
      );

      var wpcf7Elm = document.querySelector(".wpcf7");
      document.addEventListener("wpcf7invalid", function(event) {}, false);

      var wpcf7Elm = document.querySelector(".wpcf7");
      document.addEventListener(
        "wpcf7invalid",
        function(event) {
          console.log("Fire!");
        },
        false
      );

      $(window).on("wpcf7:invalid", function() {
        // let's scroll
        console.log("Fire!");
      });
    }
  },
  home: {
    init() {
      // get video asp ratio from width and height
      const videoEl = document.querySelector(".fullscreen-bg__video");
      if (videoEl) {
        // Set Playback Rate
        videoEl.playbackRate = 0.825;

        const { width, height } = {
          ...videoEl.dataset
        };
        const videoWrapper = document.querySelector(".fullscreen-bg");
        const videoAspRatio = parseInt(height) / parseInt(width);
        let videoWrapperAspRatio;
        function sizeHeroVideo() {
          const { height, width } = videoWrapper.getBoundingClientRect();
          videoWrapperAspRatio = height / width;
          if (
            videoWrapperAspRatio > videoAspRatio &&
            !videoEl.classList.contains("h")
          ) {
            videoEl.classList.add("h");
            videoEl.classList.remove("w");
          } else if (
            videoWrapperAspRatio <= videoAspRatio &&
            !videoEl.classList.contains("w")
          ) {
            videoEl.classList.add("w");
            videoEl.classList.remove("h");
          }
        }
        window.onresize = sizeHeroVideo;
        sizeHeroVideo();
      }

      // Bind down button
      const scrollDown = document.querySelector(".hero-home .scroll-down");
      if (scrollDown) {
        scrollDown.addEventListener("click", () => {
          const nextElement = document.querySelector(".hero-home + *");
          $("html, body").animate(
            {
              scrollTop: $(nextElement).offset().top
            },
            1000
          );
        });
      }
    }
  },
  insights: {
    init() {}
  },
  work: {
    init() {
      ReactDOM.render(
        <TileFilter {...const_tile_filter} />,
        document.querySelector(".tile-filter-wrapper__upper")
      );
    }
  },
  "single-case_study": {
    init() {
      $(".case-study-carousel__carousel").slick({
        rows: 0
      });
    }
  },
  "post-type-archive-case_study": {
    init() {
      ReactDOM.render(
        <PaginatedTileFilter
          base={"case-study"}
          innerProps={const_tile_filter}
        />,
        document.querySelector(".tile-filter-wrapper__upper")
      );
    }
  },
  "post-type-archive-insight": {
    init() {
      ReactDOM.render(
        <PaginatedTileFilter
          base={"insights-archive"}
          innerProps={const_tile_filter}
        />,
        document.querySelector(".tile-filter-wrapper__upper")
      );
      // ReactDOM.render(
      //   <TileFilter {...const_tile_filter} />,
      //   document.querySelector('.tile-filter-wrapper__upper')
      // )
    }
  },
  "tax-focus_area": {
    init() {
      ReactDOM.render(
        <TileFilter {...const_tile_filter} />,
        document.querySelector(".tile-filter-wrapper__upper")
      );
    }
  },
  "tax-service": {
    init() {
      $(".team-testimonial-carousel-slick").slick({
        dots: true,
        rows: 0,
        infinite: false,
        customPaging: function(slider, i) {
          const headshot = $(slider.$slides[i]).data("headshotUrl");
          return `<a href="javascript:void(0);" class="custom-slick-dot">
            &nbsp;
            <div class="headshot-dot" style="background: url(${headshot}) no-repeat center center; background-size: cover;"></div>
          </a>`;
        }
      });
    }
  },
  "single-news": {
    init() {
      loadNewsWrapper();
      newsScroll();
    }
  },
  "post-type-archive-news": {
    init() {
      loadNewsWrapper();
      newsScroll();
    }
  },
  "contact-us": {
    init() {
      // var headerTab = $(".contact-form-tabs-list li:first");
      // headerTab.addClass("active");

      $(".contact-form-tabs-list li").click(function(e) {
        // get the button we clicked
        const button = $(this);

        // find out what tab that button refers to
        // we could do it all here if we wanted
        const tabToOpenID = `#${button.data("tab")}`; // here
        // now tabToOpen = '#general-inquiries', for instance

        // get the tab to open
        const tabToOpen = $(tabToOpenID);

        // this is just a dummy check to make sure we found a pane with a matching ID
        if (tabToOpen) {
          // hide any tab that's showing
          // THIS is a very very common jquery pattern. you want to hide all the tab panes, that
          // are NOT the one you're about to show
          // let's do that first
          $(".contact-form-tabs-pane")
            .not(tabToOpen)
            .removeClass("active");
          $(".contact-form-tabs-list li")
            .not(button)
            .removeClass("active");

          // show that tab
          tabToOpen.addClass("active");
          button.addClass("active");
        }
      });
    }
  }
}).load();
